<template>
    <div class="report-container">

        <!-- 主体视界 -->
        <main class="content-main">

            <!-- 1. 顶部大标题（完美复刻） -->
            <section class="title-group">
                <h1 class="main-title-text">积沙成塔</h1>
                <div class="sub-title-wrapper">
                    <span class="sprout-icon">🌱</span>
                    <h2 class="sub-title-text">听见抽青的声音</h2>
                </div>
            </section>

            <!-- 2. 诗歌信笺流（100%保留完整文案，错落有致，绝无框框） -->
            <section class="poem-body-flow">

                <!-- 第一组：时光沉淀 -->
                <div class="text-block slide-in-1">
                    <p class="prose-line">
                        上半年，你累计坚持了
                        <span class="stat-highlight-teal">
                            <span class="din-num">{{ ReportData.studate }}</span><span class="unit">天</span>
                        </span>
                    </p>
                    <p class="prose-line">
                        在知识的原野里漫步了
                        <span class="stat-highlight-teal">
                            <span class="din-num">{{ ReportData.playtime }}</span><span class="unit">小时</span>
                        </span>
                    </p>
                </div>

                <!-- 第二组：线上斩获 -->
                <div class="text-block pad-left-1 slide-in-2" v-if="ReportData.coursenumMon>0">
                    <p class="prose-line">
                        开启了
                        <span class="stat-highlight-gold">
                            <span class="din-num">{{ ReportData.coursenumMon }}</span><span class="unit">门</span>
                        </span>线上课程，
                    </p>
                    <p class="prose-line">
                        并成功斩获了
                        <span class="stat-highlight-gold">
                            <span class="din-num">{{ ReportData.creditvalueFxbd }}</span><span class="unit">个</span>
                        </span>线上学分。
                    </p>
                </div>

                <!-- 第三组：自律与震撼数据（重头戏，优雅拉大） -->
                <div class="text-block highlight-block slide-in-3" v-if="ReportData.rate1>0 && ReportData.rate1 !== null">
                    <div class="split-line"></div>
                    <p class="prose-line font-medium">你的自律与专注，</p>
                    <p class="prose-line font-medium">
                        已经悄悄打败了
                        <span class="stat-highlight-orange">
                            <span class="din-num massive">{{ ReportData.rate1 }}</span><span
                                class="unit-percent">%</span>
                        </span> 的同行伙伴。
                    </p>
                </div>

                <!-- 第四组：情感升华金句（原汁原味） -->
                <div class="text-block footer-motto slide-in-4">
                    <p class="motto-line">不赶路，却也从未停步，</p>
                    <p class="motto-line emphasis">这就是成长最好的状态。</p>
                </div>

            </section>

        </main>

        <!-- 纤细优雅的背景光晕轨道（不抢文案风头） -->
        <div class="elegant-glow-circle"></div>
    </div>
</template>

<script>
export default {
    name: 'ReportPerfectPoemPage',
    props: ["ReportData"],
}
</script>

<style scoped>
/* 容器背景完美匹配你的亮蓝底色 */
.report-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    box-sizing: border-box;
    padding: 35px 28px;
    background:
        url("../../assets/26June/logo.png") right top no-repeat,
        url("../../assets/26June/bg.jpg") no-repeat;
    background-size: 100% 100%, cover;
    font-family: -apple-system, "SF Pro Text", "PingFang SC", "Helvetica Neue", sans-serif;
    display: flex;
    flex-direction: column;
}

/* 主体容器 */
.content-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 30px;
    z-index: 2;
}

/* 1. 大标题 */
.title-group {
    margin-bottom: 35px;
    animation: fadeInDown 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.main-title-text {
    font-size: 34px;
    font-weight: 900;
    margin: 0;
    letter-spacing: 4px;
    color: #004d40;
    /* 高级深邃墨绿 */
}

.sub-title-wrapper {
    display: flex;
    align-items: center;
    margin-top: 6px;
}

.sprout-icon {
    font-size: 19px;
    margin-right: 8px;
}

.sub-title-text {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: #1e293b;
    letter-spacing: 1px;
}

/* 2. 诗歌信笺流排版画布（没有框，靠间距和字体粗细拉开层次） */
.poem-body-flow {
    display: flex;
    flex-direction: column;
    gap: 28px;
    /* 增大间距，留出呼吸感 */
}

.text-block {
    position: relative;
}

/* 错落排版：让第二段微微往右移，打破一刀切的死板感 */
.pad-left-1 {
    padding-left: 20px;
}

/* 散文叙事线条 */
.prose-line {
    font-size: 18px;
    line-height: 1.5;
    margin: 0;
    color: #000;
    /* 优雅深蓝黑，彻底解决白字看不清的问题 */
    letter-spacing: 0.8px;
}

.font-medium {
    font-weight: 500;
}

/* --- 精致的动态高光数字设计（拒绝硬邦邦的色块） --- */
.din-num {
    font-family: "DIN Alternate", "Helvetica Neue", Arial, sans-serif;
    font-weight: 700;
    font-size: 28px;
    margin: 0 4px;
}

.unit {
    font-size: 14px;
    font-weight: 700;
}

/* 维度一颜色：松石绿 */
.stat-highlight-teal {
    color: #e65100;
    display: inline-block;
}

/* 维度二颜色：琥珀金 */
.stat-highlight-gold {
    color: #e65100;
    display: inline-block;
}

/* 第三组核心重头戏：打败同行 */
.highlight-block {
    padding-top: 15px;
}

/* 极细艺术分割线 */
.split-line {
    width: 40px;
    height: 2px;
    background: #00796b;
    opacity: 0.3;
    margin-bottom: 20px;
    border-radius: 2px;
}

.stat-highlight-orange {
    display: inline-flex;
    align-items: baseline;
}

.din-num.massive {
    font-size: 38px;
    /* 极具冲击力的大数字 */
    font-weight: 900;
    line-height: 1;
    background: linear-gradient(180deg, #d84315 0%, #e65100 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0 2px 0 6px;
}

.unit-percent {
    font-size: 18px;
    font-weight: 800;
    color: #e65100;
}

/* 第四组：完美收尾金句 */
.footer-motto {
    margin-top: 15px;
}

.motto-line {
    font-size: 15.5px;
    color: #475569;
    margin: 0 0 6px 0;
    letter-spacing: 1.5px;
}

.motto-line.emphasis {
    font-size: 18px;
    font-weight: 800;
    color: #0f172a;
    /* 极深颜色强调 */
    margin-bottom: 0;
}

/* 右侧柔和的毛玻璃渐变装饰圈（藏在文字后方，增加页面精致感） */
.elegant-glow-circle {
    position: absolute;
    width: 200px;
    height: 200px;
    right: -50px;
    bottom: 20%;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    z-index: 1;
    pointer-events: none;
}

/* --- 大厂级诗歌流专属优雅入场动画 --- */
.slide-in-1 {
    animation: fadeInBlur 0.7s cubic-bezier(0.16, 1, 0.3, 1) both;
}

.slide-in-2 {
    animation: fadeInBlur 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.15s both;
}

.slide-in-3 {
    animation: fadeInBlur 0.7s cubic-bezier(0.16, 1, 0.3, 1) 0.3s both;
}

.slide-in-4 {
    animation: fadeInBlur 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.5s both;
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-12px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInBlur {
    from {
        opacity: 0;
        transform: translateY(15px);
        filter: blur(5px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
        filter: blur(0);
    }
}

/* 小屏手机高度弹性自适应 */
@media screen and (max-height: 670px) {
    .main-title-text {
        font-size: 28px;
    }

    .poem-body-flow {
        gap: 14px;
    }

    .prose-line {
        font-size: 15px;
    }

    .din-num {
        font-size: 28px;
    }

    .din-num.massive {
        font-size: 26px;
    }

    .motto-line.emphasis {
        font-size: 15.5px;
    }
}

/* 桌面隔离沙盒 */
@media screen and (min-width: 1024px) {
    .report-container {
        width: 100% !important;
        height: 100vh !important;
        padding: 60px 10%;
        /* 侧边增加安全留白，防止内容贴边 */

        /* 单一背景图完美全屏铺满，不留任何死角 */
        background-image: url("../../assets/26June/pcbg.png") !important;
        background-position: center center !important;
        background-repeat: no-repeat !important;
        background-size: cover !important;
        /* 核心：等比例拉伸，宁可裁剪也绝不留白 */

        /* 彻底移除手机端的圆角和边界阴影 */
        border-radius: 0 !important;
        box-shadow: none !important;
        border: none !important;
    }

    .din-num {
        font-size: 38px;
    }
}
</style>